import { action, makeAutoObservable, observable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import activityService from "@services/activity/activityService"
import { ActivityTypeEnum, CustomerActivityTypeEnum } from "@lib/enum"

class ActivityStore {
  @observable isLoading: boolean = false
  @observable editActivity!: any
  @observable tableData: PagedResultDto<any> = { items: [], totalCount: 0 }
  constructor() {
    makeAutoObservable(this)
    this.editActivity = {}
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    this.editActivity = await activityService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async createActivity(
    type: ActivityTypeEnum | CustomerActivityTypeEnum,
    customerId: any,
    inquiryId?: any
  ) {
    this.editActivity = {
      id: undefined,
      type,
      customerId,
      module,
      inquiryId,
    }
  }

  @action
  async delete(id: number) {
    await activityService.delete(id)
    this.tableData.items = this.tableData.items.filter((x) => x.id !== id)
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await activityService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.editActivity = result
  }
  @action
  async emptyTable() {
    this.tableData = { items: [], totalCount: 0 }
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await activityService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default ActivityStore
